import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=3cad213c&scoped=true"
import script from "./MainTable.vue?vue&type=script&lang=js"
export * from "./MainTable.vue?vue&type=script&lang=js"
import style0 from "./MainTable.vue?vue&type=style&index=0&id=3cad213c&prod&lang=stylus&scoped=true"
import style1 from "./MainTable.vue?vue&type=style&index=1&id=3cad213c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cad213c",
  null
  
)

export default component.exports